import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[7] || (_cache[7] = [
        _createTextVNode("Delete Social Media Post")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modal = !_ctx.modal)),
            class: "btn btn-default mx-2"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deletePost && _ctx.deletePost(...args))),
            class: "btn btn-primary"
          }, "Delete Post")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Title", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "social-title",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
            readonly: "readonly"
          }, null, 512), [
            [_vModelText, _ctx.title]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "hidden",
            name: "post_id",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.id]
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("label", null, "Description", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
            readonly: "readonly",
            rows: "5"
          }, null, 512), [
            [_vModelText, _ctx.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", null, "Publish On", -1)),
          _createVNode(_component_datepicker, {
            class: "form-control",
            modelValue: _ctx.published_on,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.published_on) = $event)),
            disabled: "disabled"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}